import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-2/5">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteConfig.name}</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6 max-w-md">
              {siteConfig.description}
            </p>
            <div className="flex items-center gap-4">
              <a href={siteConfig.social.siteLink} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-links-line text-background-50"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-50"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-mail-line text-background-50"></i>
              </span>
            </div>
          </div>

          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                <a href="/category" className="hover:text-primary-400 transition-colors">热门分类</a>
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category?cat=${cat.slug}`}
                      className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                <a href="/" className="hover:text-primary-400 transition-colors">快速链接</a>
              </h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
                <li><Link to="/category" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">分类浏览</Link></li>
                <li><Link to="/about" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
                <li><Link to="/category?cat=rexue" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">热血漫画</Link></li>
                <li><Link to="/category?cat=lianai" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">恋爱漫画</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                <a href="/about" className="hover:text-primary-400 transition-colors">联系我们</a>
              </h4>
              <ul className="flex flex-col gap-2">
                <li className="text-foreground-400 text-sm whitespace-nowrap">
                  <i className="ri-mail-line mr-2"></i>{siteConfig.email}
                </li>
                <li className="text-foreground-400 text-sm whitespace-nowrap">
                  <i className="ri-phone-line mr-2"></i>{siteConfig.phone}
                </li>
                <li className="text-foreground-400 text-sm">
                  <i className="ri-map-pin-line mr-2"></i>{siteConfig.address}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All Rights Reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-foreground-500 text-xs cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</span>
            <span className="text-foreground-500 text-xs cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-foreground-500 text-xs cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}